var __TEMP__ = require('./_baseWrapperValue.js');var baseWrapperValue = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Executes the chain sequence to resolve the unwrapped value.
 *
 * @name value
 * @memberOf _
 * @since 0.1.0
 * @alias toJSON, valueOf
 * @category Seq
 * @returns {*} Returns the resolved unwrapped value.
 * @example
 *
 * _([1, 2, 3]).value();
 * // => [1, 2, 3]
 */
function wrapperValue() {
  return baseWrapperValue(this.__wrapped__, this.__actions__);
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = wrapperValue;
